var _path, _circle, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 522,
    height: 380,
    viewBox: "0 0 522 380",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M398.47 51.4194L423.009 32.333H391.921H306.846C308.025 28.9967 308.667 25.4065 308.667 21.6664C308.667 17.9262 308.025 14.336 306.846 10.9997H405.333C434.789 10.9997 458.667 34.8778 458.667 64.333V277.666C458.667 307.123 434.79 331 405.333 331H64C34.5448 331 10.6667 307.122 10.6667 277.666V64.333C10.6667 34.8779 34.5449 10.9997 64 10.9997H242.488C241.308 14.336 240.667 17.9263 240.667 21.6664C240.667 25.4064 241.308 28.9967 242.488 32.333H77.4146H46.3264L70.8659 51.4194L215.021 163.541L215.022 163.542C226.577 172.527 242.758 172.527 254.313 163.542L254.314 163.541L398.47 51.4194ZM49.2154 61.6071L32 48.2174V70.0269V277.666C32 295.34 46.3271 309.666 64 309.666H405.333C423.007 309.666 437.333 295.34 437.333 277.666V70.0269V48.2172L420.118 61.6072L267.412 180.38C267.412 180.38 267.412 180.38 267.412 180.381C248.151 195.36 221.184 195.36 201.924 180.38C201.924 180.38 201.924 180.38 201.923 180.38L49.2154 61.6071Z",
    fill: "black",
    stroke: "#C8605E",
    strokeWidth: 21.3333
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 403.667,
    cy: 262,
    r: 105,
    fill: "white",
    stroke: "#C8605E",
    strokeWidth: 26
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M459.962 264.866L459.961 264.867L414.294 310.992C414.294 310.992 414.294 310.992 414.294 310.992C412.523 312.78 409.696 312.78 407.926 310.992C406.097 309.145 406.097 306.106 407.926 304.259L407.926 304.258L427.607 284.38L445.598 266.209L420.027 266.209L350.222 266.209C347.806 266.209 345.667 264.201 345.667 261.5C345.667 258.799 347.806 256.792 350.222 256.792L420.027 256.792L445.599 256.792L427.607 238.62L407.926 218.742C406.097 216.895 406.097 213.856 407.926 212.008C409.697 210.22 412.523 210.219 414.294 212.008C414.294 212.008 414.294 212.008 414.294 212.008L459.961 258.133L459.962 258.134C460.827 259.008 461.333 260.217 461.333 261.5C461.333 262.783 460.827 263.993 459.962 264.866Z",
    fill: "black",
    stroke: "#C8605E",
    strokeWidth: 21.3333
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 243.5,
    y: 0.5,
    width: 67,
    height: 42,
    fill: "#C8605E",
    stroke: "#C8605E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessage);
export default __webpack_public_path__ + "static/media/send-message.7e3adeb35b7a015c6a377e3a8a3ac313.svg";
export { ForwardRef as ReactComponent };